import React from 'react';


const Dashboard = () => {
  return (<div>
      Admin Panel
  </div>);
};


export default Dashboard;
